module.exports = __webpack_public_path__ + "img/channel-m-2.7520795.png";